import { clsx, type ClassValue } from "clsx";
import { format, formatDistanceToNow, isValid, parseISO } from "date-fns";
import { zhCN } from "date-fns/locale";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const APP_TIMEZONE = import.meta.env.VITE_APP_TIMEZONE || "Asia/Shanghai";

export function formatDate(value?: string | null, withTime = false) {
  if (!value) return "—";
  const date = parseISO(value);
  if (!isValid(date)) return "—";
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: APP_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...(withTime ? { hour: "2-digit", minute: "2-digit", hour12: false } : {}),
  }).format(date);
}

export function relativeTime(value?: string | null) {
  if (!value) return "暂无";
  const date = parseISO(value);
  return isValid(date) ? formatDistanceToNow(date, { addSuffix: true, locale: zhCN }) : "暂无";
}

export function inputDateTimeValue(value?: string | null) {
  if (!value) return "";
  const date = parseISO(value);
  return isValid(date) ? format(date, "yyyy-MM-dd'T'HH:mm") : "";
}

export function initials(value: string) {
  return value.trim().slice(0, 2).toUpperCase() || "YK";
}

export function displayCustomerName(customer: { company_name?: string | null; contact_name?: string | null }) {
  return customer.company_name || customer.contact_name || "未命名客户";
}

